module.exports = __webpack_public_path__ + "media/JiraIntegration.201c24cb7521da9e5878b44c7ef017aa.svg";